import naPopup from './naPopup.json';
import associate from './associate';

export default {
  naPopup,
  associate,
};
